<template>
  <modal
    :show.sync="isActiveLocal"
    centered
    header-classes="bg-primary items-center rounded-none text-lg uppercase font-bold"
    modal-content-classes="cust-medi-popup cust-overflow-y-grey"
    hide-footer
    class="overflow-y-hidden"
  >
    <div class="flex justify-between pb-8">
      <div class="my-auto">
        <p class="font-medium text-2xl text-black">
          {{ selectedNeedHelp.text }}
        </p>
      </div>
      <img
        src="../../../assets/images/cross.png"
        class="h-8 w-8 cursor-pointer"
        alt="cross"
        @click="isActiveLocal = false"
      />
    </div>
    <div class="">{{ selectedNeedHelp.description }}</div>

    <p
      class="mt-2 text-primary cursor-pointer"
      v-if="selectedNeedHelp.text === 'Cancer'"
      @click="handleClick('medical_cancer')"
    >
      Know More
    </p>
    <p
      class="mt-2 text-primary cursor-pointer"
      v-if="selectedNeedHelp.text === 'Palliative'"
      @click="handleClick('medical_palliative')"
    >
      Know More
    </p>
    <p
      class="mt-2 text-primary cursor-pointer"
      v-if="selectedNeedHelp.text === 'Dementia'"
      @click="handleClick('medical_dementia')"
    >
      Know More
    </p>
    <!-- <p
      class="mt-2 text-primary cursor-pointer"
      v-if="selectedNeedHelp.text === 'Neurological Disorders'"
      @click="handleClick('medical_neurologicaldisorders')"
    >
      Know More
    </p> -->
    <template slot="footer" class="hidden"> <div></div> </template>
  </modal>
</template>

<script>
export default {
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedNeedHelp: {
      type: Object,
      default: () => {},
    },
  },

  computed: {
    isActiveLocal: {
      get() {
        return this.isActive;
      },
      set(val) {
        if (!val) {
          this.closeModal();
        }
      },
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
